import React, { useEffect, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { enableDodAtom } from '../../../../atoms';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { formatMetricDataForChart } from '../../../utils/format';
import { TrendContainer } from './styled';

export interface TrendProps {
  data: any[];
  metricKey: string;
  style?: React.CSSProperties;
  dodData?: any[];
}

const Trend = ({ data = [], metricKey, style, dodData = [] }: TrendProps) => {
  const { instance, chartInstanceRefCb } = useChartInstance({});
  const dodEnabled = useAtomValue(enableDodAtom);

  const chartOption = useMemo(
    () =>
      formatMetricDataForChart({
        chartData: data,
        metricKey,
        ...(dodEnabled && dodData.length > 0 ? { dodData } : {}),
      }),
    [data, metricKey, dodEnabled, dodData],
  );

  useEffect(() => {
    if (instance && chartOption) {
      instance.setOption(chartOption, { notMerge: true });
      // Trigger resize after mount in case echarts initialised before the
      // container had its final dimensions (e.g. inside virtualised table rows)
      requestAnimationFrame(() => instance.resize());
    }
  }, [instance, chartOption]);

  return (
    <TrendContainer style={style}>
      <BaseChart
        chartId={`widget-flow-trend-${metricKey}`}
        chartInstanceRefCb={chartInstanceRefCb}
        style={{ height: '100%', width: '100%' }}
      />
    </TrendContainer>
  );
};

export default React.memo(Trend);
